import { render, staticRenderFns } from "./PromotionStandard.vue?vue&type=template&id=160afa5c&"
import script from "./PromotionStandard.vue?vue&type=script&lang=js&"
export * from "./PromotionStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports